import { identity } from './function.no-deps'
import { compose } from './compose.no-deps'

/**
 * Like the |> operator from elm.
 * So something than looks like this in elm:
 *
 *     myList
 *         |> List.map .id
 *         |> List.foldr List.concat
 *         |> UniqueList.fromList
 *
 * Might look something like this in typescript:
 *
 *     pipe(myList, map(m => m.id), flatten, uniq)
 */
export function pipe<T1>(value: T1): T1
export function pipe<T1, T2>(value: T1, f1: (t: T1) => T2): T2
export function pipe<T1, T2, T3>(value: T1, f1: (t: T1) => T2, f2: (t: T2) => T3): T3
export function pipe<T1, T2, T3, T4>(value: T1, f1: (t: T1) => T2, f2: (t: T2) => T3, f3: (t: T3) => T4): T4

export function pipe<T1, T2, T3, T4, T5>(
    value: T1,
    f1: (t: T1) => T2,
    f2: (t: T2) => T3,
    f3: (t: T3) => T4,
    f4: (t: T4) => T5
): T5

export function pipe<T1, T2, T3, T4, T5, T6>(
    value: T1,
    f1: (t: T1) => T2,
    f2: (t: T2) => T3,
    f3: (t: T3) => T4,
    f4: (t: T4) => T5,
    f5: (t: T5) => T6
): T6

export function pipe<T1, T2, T3, T4, T5, T6, T7>(
    value: T1,
    f1: (t: T1) => T2,
    f2: (t: T2) => T3,
    f3: (t: T3) => T4,
    f4: (t: T4) => T5,
    f5: (t: T5) => T6,
    f6: (t: T6) => T7
): T7

export function pipe<T1, T2, T3, T4, T5, T6, T7, T8>(
    value: T1,
    f1: (t: T1) => T2,
    f2: (t: T2) => T3,
    f3: (t: T3) => T4,
    f4: (t: T4) => T5,
    f5: (t: T5) => T6,
    f6: (t: T6) => T7,
    f7: (t: T7) => T8
): T8

export function pipe<T1, T2, T3, T4, T5, T6, T7, T8, T9>(
    value: T1,
    f1: (t: T1) => T2,
    f2: (t: T2) => T3,
    f3: (t: T3) => T4,
    f4: (t: T4) => T5,
    f5: (t: T5) => T6,
    f6: (t: T6) => T7,
    f7: (t: T7) => T8,
    f8: (t: T8) => T9
): T9

export function pipe<T1, T2, T3, T4, T5, T6, T7, T8, T9, T10>(
    value: T1,
    f1: (t: T1) => T2,
    f2: (t: T2) => T3,
    f3: (t: T3) => T4,
    f4: (t: T4) => T5,
    f5: (t: T5) => T6,
    f6: (t: T6) => T7,
    f7: (t: T7) => T8,
    f8: (t: T8) => T9,
    f9: (t: T9) => T10
): T10

export function pipe<T1, T2, T3, T4, T5, T6, T7, T8, T9, T10, T11>(
    value: T1,
    f1: (t: T1) => T2,
    f2: (t: T2) => T3,
    f3: (t: T3) => T4,
    f4: (t: T4) => T5,
    f5: (t: T5) => T6,
    f6: (t: T6) => T7,
    f7: (t: T7) => T8,
    f8: (t: T8) => T9,
    f9: (t: T9) => T10,
    f10: (t: T10) => T11
): T11

export function pipe(
    value: unknown,
    f1: (t: unknown) => unknown = identity,
    f2: (t: unknown) => unknown = identity,
    f3: (t: unknown) => unknown = identity,
    f4: (t: unknown) => unknown = identity,
    f5: (t: unknown) => unknown = identity,
    f6: (t: unknown) => unknown = identity,
    f7: (t: unknown) => unknown = identity,
    f8: (t: unknown) => unknown = identity,
    f9: (t: unknown) => unknown = identity,
    f10: (t: unknown) => unknown = identity
) {
    return compose(f1, f2, f3, f4, f5, f6, f7, f8, f9, f10)(value)
}
